module.exports = __webpack_public_path__ + "static/img/zy_nv.png";